
































import { Component } from '@niknevis/vue-modules'
import { Prop, ProvideReactive } from 'vue-property-decorator'
import { LatestNewsCollection } from '@/modules/news/models/news-collection.model'
import { DateHelper } from '@/modules/shared/helpers/date'
import NewsForm from '@/modules/news/components/admin/NewsForm.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { NewsEditUseCase } from '@/modules/news/use-cases/admin/news-edit.use-case'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import { mixins } from 'vue-class-component'
import DialogMixin from '@/modules/common/dialog/mixins/DialogMixin'
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import { LatestNewsCategory } from '@/modules/news/models/news-resource.model'

@Component({
  components: { Modal, NewsForm, BaseButton }
})
export default class NewsEdit extends mixins<DialogMixin>(DialogMixin) {
  constructor(
    private readonly dateHelper: DateHelper,
    private readonly useCase: NewsEditUseCase
  ) {
    super()
  }

  $refs: {
    dialog: QDialog
  }

  @Prop() newsItem!: LatestNewsCollection
  @Prop() categories!: { [key in LatestNewsCategory]: string }
  private editNewsBtnLabel: string = 'ذخیره تغییرات'
  private editNewsCancelBtnLabel: string = 'انصراف'
  private dialogModel = true

  @ProvideReactive()
  news = { data: { ...this.newsItem }, ...this.categories }

  updateNews() {
    this.useCase.execute(this.newsItem.id, this.newsItem).then(() => {
      if (this.useCase.isSuccess) this.dialogModel = false
    })
  }

}
